import katex from 'katex';
import 'katex/dist/contrib/mhchem.js';
const formulaCache = new Map();
export const formulaPattern = () => /\$\$([\s\S]*?)\$\$|\\\[([\s\S]*?)\\\]|\\\(([\s\S]*?)\\\)|(?<!\\)\$([^$\n]+?)(?<!\\)\$|([A-Za-z\u03b1-\u03c9][A-Za-z0-9]*(?:[_^]\{[^{}\n]+\})(?:[A-Za-z0-9]*(?:[_^]\{[^{}\n]+\}))*(?:[A-Za-z0-9]+)?)/g;
export function normalizeQuestionText(value, hasImages = false) {
  return String(value ?? '').replace(/[\u200b-\u200d\ufeff]/g, '')
    .replace(/<ImageHere>/gi, hasImages ? '（见配图）' : '（图示待补充）')
    .replace(/\\\$([^\n]*?\\[a-zA-Z][^\n]*?)\\\$/g, '$$$1$');
}
export function renderFormula(tex, displayMode = false) {
  const key = `${displayMode}:${tex}`;
  if (formulaCache.has(key)) return formulaCache.get(key);
  let normalized = tex.replace(/\u000crac\b/g, '\\frac').replace(/\u0008(div|igcirc|ecause|egin|ar|eta)\b/g, (_, tail) => `\\b${tail}`)
    .replace(/\\degree\b/g, '^{\\circ}')
    .replace(/\\bdiv\b/g, '\\div').replace(/\\bigcirc\b/g, '\\mathbin{\\bigcirc}')
    .replace(/\\overparen\b/g, '\\overset{\\frown}').replace(/\\txt\b/g, '\\text')
    .replace(/\\left\{/g, '\\left\\{').replace(/\\right\}/g, '\\right\\}')
    .replace(/\^\{([^{}]+)\}\^\{([＋+−-])\}/g, '^{$1$2}');
  // Adjacent source subscripts refer to one label (e.g. G_{磁}_{铁}).
  while (/_\{([^{}]+)\}_\{([^{}]+)\}/.test(normalized)) normalized = normalized.replace(/_\{([^{}]+)\}_\{([^{}]+)\}/g, '_{$1$2}');
  if (/\\\\begin\b/.test(normalized) && /\\\\end\b/.test(normalized)) normalized = normalized.replace(/\\\\/g, '\\');
  let result;
  try {
    result = { html: katex.renderToString(normalized, {
      displayMode, throwOnError: true, trust: false, strict: 'ignore', maxExpand: 1000, maxSize: 20
    }) };
  } catch (error) { result = { error: true }; }
  if (formulaCache.size >= 512) formulaCache.delete(formulaCache.keys().next().value);
  formulaCache.set(key, result);
  return result;
}
